module.exports = __webpack_public_path__ + "static/media/office-option-vector.66b64291.svg";